module.exports = {"id":"198329","name":"Rodrigo","rating":"81","photo":"./data/images/photos/4/198329.png","club":{"name":"Valence CF","logo":"./data/images/clubs/ValenceCF.png"},"positions":["BU","AD","AG","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Rodrigo0.json
// module id = 3662
// module chunks = 0